import { useGoogleLogin } from "@react-oauth/google";
import { externalLoginAction } from "@redux/actions";
import React from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";

const LoginWithGoogle = () => {
  // state

  // variables

  // logics before hooks

  // hooks
  const dispatch = useDispatch();
  const googleLogin = useGoogleLogin({
    onSuccess: (token) =>
      dispatch(externalLoginAction(["google", token.access_token])),
  });

  // logics

  // UI partials

  // effects

  // render
  return (
    <Button variant="outline-primary" onClick={() => googleLogin()}>
      <i className="bi bi-google mr-2" /> Continue with Google
    </Button>
  );
};

/* required: display name */
LoginWithGoogle.displayName = "LoginWithGoogle";

/* required: props types */
LoginWithGoogle.propTypes = {};

/* required: default props */
LoginWithGoogle.defaultProps = {};

export { LoginWithGoogle };
